import { useCallback, useLayoutEffect, useState,useMemo } from 'react';
import {
  ReactFlow,
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  useNodesState,
  useEdgesState,
  Background,
  BackgroundVariant,
  Edge,
  Controls,
  MarkerType,
  MiniMap,
  Panel,
  DefaultEdgeOptions,
  useReactFlow,
  ReactFlowProvider
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import {SimpleTraitNodes,SinglVectorTraitNodes,MultiTraitNodes,SingleTraitNode} from './CustomNodes';
import {initialNodes,initialEdges,childrenData} from './nodes-edges'
import dagre from 'dagre';
import { debounce } from 'lodash';  

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const nodeWidth = 172;
const nodeHeight = 36;
const parentPadding = 30; // Padding inside parent nodes
const nodeMargin = 50; 

const nodeTypes = {simpletrait: SimpleTraitNodes,singlvectortrait: SinglVectorTraitNodes,multitrait: MultiTraitNodes,singletrait: SingleTraitNode}

// const getLayoutedElements = (nodes:any, edges:any, direction = 'TB') => {
//     const isHorizontal = direction === 'LR';
//     dagreGraph.setGraph({ rankdir: direction });
  
//     nodes.forEach((node:any) => {
//       dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
//     });
  
//     edges.forEach((edge:any) => {
//       dagreGraph.setEdge(edge.source, edge.target);
//     });
  
//     dagre.layout(dagreGraph);
  
//     console.log('dagreGraph',dagreGraph)
  
//   console.log('dagre',dagre)  
  
//     const newNodes = nodes.map((node:any) => {
//       const nodeWithPosition = dagreGraph.node(node.id);
//       console.log(`nodewithposition for id ${node.id}`,nodeWithPosition)
//       const newNode = {
//         ...node,
//         targetPosition: isHorizontal ? 'left' : 'top',
//         sourcePosition: isHorizontal ? 'right' : 'bottom',
//         // We are shifting the dagre node position (anchor=center center) to the top left
//         // so it matches the React Flow node anchor point (top left).
//         position: {
//           x: nodeWithPosition.x - nodeWidth / 2,
//           y: nodeWithPosition.y - nodeHeight / 2,
//         },
//       };
  
//       return newNode;
//     });
  
//     return { nodes: newNodes, edges };
//   };

// const calculateNodePositions = (nodes:any) => {
//     console.log(nodes)
//     const setNodes:any = new Set();
//     let yOffset=0
    
//     // Group nodes by their parent
//     nodes.forEach((node:any) => {
//       if(node.parentId){
//         if(setNodes.has(node.parentId)){
//             node.position.y=yOffset
//             yOffset+=41
//        }else{
//          yOffset=0
//          node.position.y=yOffset
//          yOffset+=41
//          setNodes.add(node.parentId)
//        }
//       }
//     });

//     return nodes

//   };

const ShaderFrogComponents = () => {
    
    // const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(
    //     initialNodes,
    //     initialEdges,
    //   );

    // const layoutnodes = calculateNodePositions(initialNodes)
      
    const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes as any);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const { getNode, getNodes, getIntersectingNodes } = useReactFlow();

  const adjustNodePositions = useMemo(() => debounce((event:any,node:any) => {
    const intersections = getIntersectingNodes(node).filter((n:any) => n.id !== node.id);
    
    if (intersections.length > 0) {
      const newNodes = getNodes().map((n:any) => {
        if (intersections.some((int:any) => int.id === n.id)) {
          const dx = node.position.x - n.position.x;
          const dy = node.position.y - n.position.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          const minDistance = 100;

          if (distance < minDistance) {
            const angle = Math.atan2(dy, dx);
            const newX = n.position.x - (minDistance - distance) * Math.cos(angle);
            const newY = n.position.y - (minDistance - distance) * Math.sin(angle);

            return {
              ...n,
              position: { x: newX, y: newY },
            };
          }
        }
        return n;
      });

      setNodes(newNodes);
    }
  }, 1), [getNodes, getIntersectingNodes, setNodes]);

//   const onNodeDrag = useCallback((event:any, node:any) => {
//     adjustNodePositions(event,node);
//   }, [adjustNodePositions]);


  
  const handleAddTraitToParent = useCallback((parentNodeId:string) => {
    const newNode = {
        id: `node-${crypto.randomUUID()}`,
        type: "singletrait",
        hidden: false,
        data: {
          name: "color",
          type: "vector3",
          outputType: "vector4"
        },
        position: { x: 0, y: 0 },
        parentId: parentNodeId,
        extent: "parent",
        draggable:false
      }

      let childcount=nodes.filter((node:any)=>node.parentId===parentNodeId).length
      newNode.position.y=100+(childcount*41)

      if(100+(childcount*41)>500){
        return
      }

      setNodes((ns:any) => [...ns, newNode]);
    

  },[nodes,setNodes])

  const onConnect = useCallback(
    (params:any) =>
      setEdges((eds:any) =>
        addEdge(
          { ...params },
          eds,
        ),
      ),
    [],
  );

  const modifiedNodes = useMemo(() =>nodes.map((node:any) => ({
    ...node,
    data: { ...node.data, onAddNode: handleAddTraitToParent }
  })),[nodes])

  return (
    <ReactFlow
  nodes={modifiedNodes}
  edges={edges}
  onNodesChange={onNodesChange}
  onEdgesChange={onEdgesChange}
  onConnect={onConnect}
  nodeTypes={nodeTypes}
  onNodeDrag={adjustNodePositions}
  nodesDraggable={true}
//   defaultEdgeOptions={defaultEdgeOptions}
  connectionLineStyle={{ stroke: 'black' }}
  fitView
>
    
    <Controls />
    <MiniMap />
    <Background variant={BackgroundVariant.Dots} />
</ReactFlow>
  )
}

const MainReactFlow = () => {
  return (
    <ReactFlowProvider>
      <ShaderFrogComponents />
    </ReactFlowProvider>
  )

}

export default MainReactFlow